import styled from 'styled-components';

const ListInfoCardSingleRow = styled.div`
  padding: 16px 0 0;
`;

export default ListInfoCardSingleRow;
